import React, { memo } from "react";

/**
 * SectionTitle — section header with optional icon and domain accent.
 *
 * Props:
 *   title   — required string
 *   icon    — optional Lucide icon component (13px, discrete)
 *   domain  — optional domain key ("pastoral", "organization", etc.) → accent color
 *   tone    — optional simple color key ("emerald", "amber", etc.) → icon color override
 *   action  — optional right-side CTA element
 *   className — optional className on the root element
 *
 * Backward compatible: existing usages without icon/domain/tone are unchanged.
 */

const TONE_CLASS = {
  red:     "text-red-500 dark:text-red-400",
  amber:   "text-amber-500 dark:text-amber-400",
  emerald: "text-emerald-500 dark:text-emerald-400",
  blue:    "text-blue-500 dark:text-blue-400",
  violet:  "text-violet-500 dark:text-violet-400",
  green:   "text-green-500 dark:text-green-400",
  yellow:  "text-yellow-500 dark:text-yellow-400",
  slate:   "text-slate-400 dark:text-slate-500",
  teal:    "text-teal-500 dark:text-teal-400",
  purple:  "text-purple-500 dark:text-purple-400",
  indigo:  "text-indigo-500 dark:text-indigo-400",
};

const DEFAULT_ICON_COLOR = "text-slate-400 dark:text-slate-500";

const SectionTitle = memo(function SectionTitle({
  title,
  icon: Icon,
  domain,
  tone,
  action,
  className = "",
}) {
  return (
    <div className={`flex items-center gap-2 mb-2.5 ${className}`}>

      {Icon && (
        <Icon size={13} className={`shrink-0 ${DEFAULT_ICON_COLOR}`} />
      )}

      <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">
        {title}
      </p>

      <div className="h-px flex-1 bg-slate-200/60 dark:bg-slate-700/50" />

      {action && <div className="shrink-0">{action}</div>}

    </div>
  );
});

export default SectionTitle;
